import React, { Component } from "react";
import { connect } from "react-redux";
import Input from "@material-ui/core/Input";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import { PublishRounded, DeleteForever, Home } from "@material-ui/icons";
import { ReactComponent as Error } from "../../CheckoutProcess/assets/close.svg";

export class ImageField extends Component {
  handleImageUpload = async (e) => {
    const image = e.target.files[0];
    var reader = new FileReader();
    if (image && image.type.includes("image")) {
      reader.readAsDataURL(image);
      reader.onload = () => {
        this.props.handleImageUpload({
          image: reader.result,
          name: image.name,
        });
      };
    }
  };

  render() {
    const { customTexts, language, home_picture } = this.props;

    const filename = home_picture ? home_picture.name : null;
    return (
      <>
        <input
          onChange={this.handleImageUpload}
          accept="image/*"
          style={{ display: "none" }}
          id="raised-button-file"
          multiple
          type="file"
        />
        <label
          className="pointer"
          htmlFor="raised-button-file"
          style={{
            width: filename ? "93%" : "100%",
            position: "relative",
            top: 31,
            textAlign: language === "english" ? "left" : "right",
            zIndex: "1",
            right: filename ? (language === "english" ? "3%" : "-3%") : "",
          }}
        >
          <Button
            style={{ textTransform: "none", width: "95px" }}
            className="p-1 mb-2"
            variant="contained"
            color="primary"
            component="span"
          >
            <span>
              {language === "english" ? "Choose image" : "إختار صورة"}
            </span>
          </Button>
        </label>

        <TextField
          style={{ pointerEvents: "none" }}
          id="additionalTextField"
          color="primary"
          key={"additionalKey"}
          name="additional"
          fullWidth
          placeholder={
            language === "english"
              ? customTexts.upload_home_picture
              : customTexts.upload_home_picture_ar
          }
          value={filename || ""}
          onChange={this.props.handleChange}
          InputLabelProps={{
            style: {
              right: language == "arabic" && 5,
              left: language == "english" ? 25 : 0,
            },
            dir: language == "english" ? "ltr" : "rtl",
          }}
          InputProps={{
            style:
              language == "english"
                ? {
                    paddingLeft: 105,
                  }
                : {
                    paddingRight: 105,
                  },
            dir: language == "english" ? "ltr" : "rtl",
          }}
        />
        {filename && (
          <Error
            className="pointer"
            width={15}
            height={15}
            onClick={() => this.props.handleImageUpload(null)}
            style={{
              position: "relative",
              float: language === "english" ? "right" : "left",
              bottom: 23,
            }}
          />
        )}
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  language: state.store.language,
  customTexts: state.store.store.settings.custom_texts,
});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(ImageField);
